module.exports = "/img/like.svg?4cf4078e09ff328750010e50d2822ba6";